import dataTableView from './dataTableComponent.html';
import './dataTableComponent.css';
import { ensure } from 'components/sharpr/ensure/ensure';

export function dataTableComponent() {
	return {
		bindings: {
			columns: '<',
			endpoint: '@?',
			headers: '=?',
			provider: '<?',
			actions: '<?',
			image: '<?',
			checkbox: '<?',
			transformer: '<?',
			limit: '<?',
			defaultSort: '@?',
			rowAction: '<?',
			filters: '=?',
			bindUrl: '@?',
			loadingMessage: '<?',
		},
		controllerAs: 'vm',
		controller: dataTableComponentCtrl,
		template: dataTableView,
	};
}

export class dataTableComponentCtrl {
	constructor($scope, Api, $timeout, UrlData) {
		'ngInject';
		// save injections
		this.$scope = $scope;
		this.Api = Api;
		this.$timeout = $timeout;
		this.UrlData = UrlData;
	}

	$onChanges = async changes => {
		if (changes?.provider?.currentValue || changes?.endpoint?.currentValue) {
			this.loadData();
		}
	};

	$onInit() {
		// watch for changing sort or filters
		if (this.loadingMessage === undefined) {
			this.loadingMessage = 'Loading...';
		}
		this.paging = {
			sort: this.defaultSort || '',
			limit: this.limit || 10,
			page: 1,
		};
		if (this.bindUrl) {
			const criteria = {
				filters: this.filters,
				paging: this.paging,
				headers: this.headers,
			};
			this.UrlData.bindAllAs(this.$scope, this.bindUrl, criteria, this.loadData.bind(this));
		} else {
			this.loadData();
		}
	}

	getParams() {
		const filters = this.filters || {};
		return {
			...this.paging,
			...filters,
		};
	}

	setUseInitials(item) {
		item.useInitials = false;
		// store user's avatar into a variable we can resuse
		const avatar = ensure.string(item.avatar);
		//
		// decide to show gravatar, uploaded image or initials
		//
		if (String(item.is_active) === '0') {
			// for privacy reasons, never show an inactive user's avatar
			item.useInitials = true;
		} else if (avatar.match(`avatar-placeholder`)) {
			// replace the default one with initials
			item.useInitials = true;
		} else if (!avatar) {
			item.useInitials = true;
		}
	}

	loadData() {
		const params = this.getParams();
		if (this.loadingMessage) {
			// hide data and show "Loading..." or whatever Loading Message is
			this.data = [];
		}
		this.isLoading = true;
		this.hasNoData = false;

		this._getProviderPromise(params).then(resp => {
			const total =
				parseInt(resp.total || (resp.headers && resp?.headers('API-Total-Records')) || resp?.data?.length) || 0;
			let promise;
			if (this.transformer) {
				let transformed = this.transformer({
					data: ensure.array(resp.data),
					total,
				});
				promise = ensure.promise(transformed);
			} else {
				promise = Promise.resolve({ data: resp.data, total });
			}
			promise.then(
				records => {
					this.data = ensure.array(records.data);
					this.data.map(item => {
						this.setUseInitials(item);
					});
					this.numPages = Math.ceil(records.total / (records.limit || this.paging.limit));
					if (this.data.length === 0 && records.total > 0) {
						// we are on a page with no data; go back to page one
						this.paging.page = 1;
					} else {
						this.isLoading = false;
						this.hasNoData = this.data.length === 0;
					}
					this.$timeout(() => {});
				},
				reason => {
					console.log('sh-data-table could not get the records:', reason);
				}
			);
		});
	}

	_getProviderPromise(params) {
		if (this.endpoint) {
			if (this._pendingRequest?.abort) {
				this._pendingRequest.abort();
			}
			this._pendingRequest = this.Api.request('GET', this.endpoint, params, this.headers || {});
			return this._pendingRequest;
		} else if (typeof this.provider == 'function') {
			return ensure.promise(this.provider(params));
		}

		// otherwise provider has not yet been set
		console.warn('dataTableComponent: You must specify "endpoint" or "provider" to load data.');
		return Promise.resolve({ data: [], total: 0 });
	}

	doAction(action, row, event) {
		if (typeof action.callback == 'function') {
			action.callback(row);
		}
		if (this.rowAction) {
			event.stopPropagation();
		}
	}

	doRowAction(row) {
		if (this.rowAction) {
			this.rowAction(row);
		}
	}

	doCheckboxAction(row, event) {
		let newState = !row[this.checkbox.field];
		row[this.checkbox.field] = newState;
		event.target.previousSibling.checked = newState;
		if (typeof this.checkbox.callback == 'function') {
			this.checkbox.callback(row);
		}
		if (this.rowAction) {
			event.stopPropagation();
		}
	}

	getColspan() {
		return (
			this.columns.length + (this.image ? 1 : 0) + (this.checkbox ? 1 : 0) + (this.actions && this.actions.length ? 1 : 0)
		);
	}
}
